import { Box } from "@mui/material";
import arkMockup from "../../assets/mock-ups/ark.png";

export function ArkJobContent() {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      width="100%"
      pt={{ xs: 4, md: 4 }}
    >
      <Box
        component="img"
        src={arkMockup}
        alt="Ark app mockup"
        sx={{
          borderRadius: 0,
          height: { xs: "180px", sm: "300px", md: "300px" },
          objectFit: "contain",
          userSelect: "none",
          pointerEvents: "none",
        }}
        draggable={false}
      />
    </Box>
  );
}
